import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { UserService, CustomerType, SelectedCustomer } from './../../services/user.service';
import { AuthService } from 'app/services/auth.service';
import { PaneHeaderService } from 'app/services/pane-header.service';
import { TooltipHelpService, TooltipPopoutData } from 'app/services/tooltip-help.service';
import { PopoutModalService } from 'app/services/popout-modal.service';
import { ActivityService } from 'app/services/activity.service';
import { LayerService } from 'app/services/layer.service';
import { ContentMenuItemKey, MainDataService, ModelMenuItemKey, SchemaDefinedBy } from 'app/services/main-data.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { TestLayerSelectComponent, TestLayerSelectInputData } from '../modal/test-layer-select/test-layer-select.component';
import { CommonFunctionService } from 'app/services/common-function.service';
import { AppSettings } from 'app/app.settings';
import { MatDialogConfig } from '@angular/material';
import { FeatTransactionLogComponent} from 'app/components/feat-transaction-log/feat-transaction-log.component';
import { TransactionLogService } from 'app/services/transaction-log.service';
import { ResolutionCenterService } from 'app/services/resolution-center.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { ClearService } from 'app/services/clear.service';
import { QcLayerSelectModalComponent, QcLayerSelectModalInput } from '../modal/qc-layer-select-modal/qc-layer-select-modal.component';
import { AdminService } from 'app/services/admin.service';
import { FishboneService } from 'app/services/fishbone.service';
import { FeatReferenceDocumentComponent, ReferenceDocumentInputData } from '../feat-reference-document/feat-reference-document.component';
import { BookmarkService, MapBookmark } from 'app/services/bookmark.service';

export interface ContentMenuItem {
	key: ContentMenuItemKey;
	label: string;
	navigateCommands?: any[];
	hasSchemaMenu?: boolean;
	hasMapFilter?: boolean;
}

export interface SettingsMenuItem {
	label: string;
	navigateCommands?: any[];
	onClick?: Function;
	tooltip?: string;
	hidden?: boolean;
}
export interface UserMenuItem {
	label: string;
	key: 'user' | 'logout',
	tooltip?: string;
	className?: string;
}

export interface ModelItem {
	label: string;
	value: ModelMenuItemKey;
}

@Component({
	selector: 'app-pane-header',
	templateUrl: './pane-header.component.html',
	styleUrls: ['./pane-header.component.css']
})
export class PaneHeaderComponent implements OnInit, OnDestroy {

	public agencyName: string;
	public userName: string;
	public userRole: string;
	public customerType: CustomerType;
	public selectedCustomer: SelectedCustomer;
	public agencyParentName: string;

	public selectedCustomerId: number;
	public selfCustomerId: number;

	public isAdminUser: boolean;

	public longTransactionClass: string = '';

	public selectedContentMenu: ContentMenuItem;;
	public contentMenus: ContentMenuItem[] = [
		{
			key: 'home',
			label: 'Dashboard',
			navigateCommands: ['/azgiv/dashboard']
		},
		{
			key: 'live',
			label: 'Live Layers',
			hasSchemaMenu: true,
			hasMapFilter: true,
			navigateCommands: ['/azgiv/layers/live-layers']
		}, {
			key: 'report',
			label: 'Analysis',
			hasSchemaMenu: true,
			hasMapFilter: true,
			navigateCommands: ['/azgiv/layers/reports']
		}, {
			key: 'published',
			label: 'Published Layers',
			hasSchemaMenu: true,
			hasMapFilter: true,
			navigateCommands: ['/azgiv/layers/published-layers']
		}
	];
	public selectedSchema: SchemaDefinedBy;
	public schemaDefinedByList: SchemaDefinedBy[];
	//
	selectedModel: ModelItem;
	modelList: ModelItem[] = [{
		label: 'All',
		value: ''
	}, {
		label: 'NextGen',
		value: 'N'
	}, {
		label: 'Legacy',
		value: 'L'
	}];
	hasModelMenu = false;
	showAllField: boolean; // Has the 'All Fields' option in model list or not

	//
	public settingsMenu: SettingsMenuItem[];;
	public userMenu: UserMenuItem[] = [
		{
			label: 'UserName', // updated in ngOnInit
			key: 'user',
			// className: 'glyphicons glyphicons-user'
		}, {
			label: 'Sign out',
			key: 'logout',
			className: 'glyphicons glyphicons-log-out'
		}
	];

	private stopClickEvent: boolean;

	private contentMenuItemKeySub: Subscription;
	private selectedCustomerSub: Subscription;
	private changeCustomerSub: Subscription;
	// private selectViewFromCodeSub: Subscription;
	private modelSub: Subscription;
	private modelOptionSub: Subscription;
	private selectedLayerSub: Subscription;
	private transactionLogSub: Subscription;

	constructor(
		private router: Router,
		private cdRef: ChangeDetectorRef,
		private authService: AuthService,
		private activityService: ActivityService,
		private adminService: AdminService,
		private attrIndexService: AttrIndexService,
		private bookmarkService: BookmarkService,
		private clearService: ClearService,
		private commonService: CommonFunctionService,
		private fishboneService: FishboneService,
		private layerService: LayerService,
		private qcService: LayerQcService,
		private mainDataService: MainDataService,
		private mapService: MainDataMapService,
		private modalService: CommonModalService,
		private paneHeaderService: PaneHeaderService,
		private popoutModalService: PopoutModalService,
		private resolutionCenterService: ResolutionCenterService,
		private tooltipHelpService: TooltipHelpService,
		private userService: UserService,
		private transactionLogService: TransactionLogService
	) { }

	async onChangeCustomer(e) {
		//
	}

	public onChangeContentMenu(e) {
		console.log(e);
	}
	// This is for case when selectedContentMenu and route doesn't match, and clicking on menu won't trigger selectContentMenu
	clickContentMenu(item: ContentMenuItem) {
		if (this.stopClickEvent) {
			this.stopClickEvent = false;
			return;
		}
		console.log('click content menu')
		this.router.navigate(item.navigateCommands);
	}
	async selectContentMenu(item: ContentMenuItem, skipNavigation?: boolean, stopClickEvent?: boolean) {
		this.stopClickEvent = stopClickEvent;
		const prev = this.selectedContentMenu;
		this.selectedContentMenu = item;
		if (item) {
			if (item.navigateCommands && !skipNavigation) {
				const isSuccessNavigate = await this.router.navigate(item.navigateCommands);
				if (isSuccessNavigate || isSuccessNavigate === null) {
						// // Set view
						// const views = this.contentLayerService.viewsBS.getValue();
						// if (views[item.key]) {
						// 	const viewItem = this.viewList.find(v => v.key === views[item.key]);
						// 	this.selectView(viewItem);
						// }
					// Set schema
					const schemas = this.mainDataService.schemasDefinedByBS.getValue();
					if (schemas[item.key]) {
						const schemaItem = this.schemaDefinedByList.find(s => s.value === schemas[item.key].currentDefinedBy);
						this.selectSchema(schemaItem);
					}
				} else if (isSuccessNavigate === false) { // If isSuccessNavigate is null, don't rollback to prev menu
					setTimeout(() => {
						this.selectedContentMenu = prev;
						this.cdRef.detectChanges();
					});
				}
			}
		}
	}
	onClickSettingMenu(item: SettingsMenuItem) {
		if (item.onClick) {
			item.onClick();
		} else if (item.navigateCommands) {
			this.router.navigate(item.navigateCommands);
		}
	}
	public selectSchema(item: SchemaDefinedBy) {
		this.selectedSchema = item;
		const schemas = this.mainDataService.schemasDefinedByBS.getValue();
		schemas[this.selectedContentMenu.key].currentDefinedBy = item.value;
		this.mainDataService.schemasDefinedByBS.next(schemas);
		
		this.hasModelMenu = this.checkHasModelMenu();
	}
	selectModel(item: ModelItem) {
		this.mainDataService.modelBS.next(item.value);
	}

	public clickUserMenuItem(item: UserMenuItem) {
		switch (item.key) {
			case 'user': break;
			case 'logout': this.clearService.logout();
		}
	}

	async clickTooltipHelp() {
		// let isOn = this.tooltipHelpService.isHelpOnBS.getValue();
		// if (!isOn) {
		// 	isOn = true;
		// 	this.tooltipHelpService.isHelpOnBS.next(isOn);
		// }
		if (!this.qcService.qaRuleDetails) {
			await this.qcService.getAllQaRulesWithDetail();
		}
		this.tooltipHelpService.isHelpOnBS.next(true);
		this.openTooltipHelpPopout();
	}

	async clickTransactionLog() {
		const options: MatDialogConfig = {
			height: '80%',
			width: '550px'
		}
		const rsp = await this.modalService.openModalWindow(FeatTransactionLogComponent, options);
		// this.transactionLogService.isTransactionLogOnBS.next(true);
		// const modalName = 'transactionLog';
		// const modalData: TooltipPopoutData = {
		// 	modalName: modalName,
		// 	modalWindowName: 'Logs',
		// 	onWindowClose: (e) => {
		// 		this.transactionLogService.isTransactionLogOnBS.next(false);
		// 	}
		//   };
	  	  
		// if (!this.popoutModalService.isPopoutOpen(modalName)) {
		// 	this.popoutModalService.openPopoutModal(modalData);
		// } else {
		// 	this.popoutModalService.focusPopoutWindow(modalName);
		// }
	}
	private openTooltipHelpPopout() {
		const modalName = 'tooltipHelp';
		const modalData: TooltipPopoutData = {
			modalName: modalName,
			modalWindowName: 'Helps',
			onWindowClose: (e) => {
				this.tooltipHelpService.isHelpOnBS.next(false);
			}
		  };
	  	  
		if (!this.popoutModalService.isPopoutOpen(modalName)) {
			this.popoutModalService.openPopoutModal(modalData);
		} else {
			this.popoutModalService.focusPopoutWindow(modalName);
		}
	}

	private checkHasModelMenu(): boolean {
		if (!this.selectedContentMenu || this.selectedContentMenu.key === 'home') {
			return false;
		}
		if (!this.selectedSchema || this.selectedSchema.value === 'local') {
			return false;
		}
		const selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
		if (!selectedLayer || !selectedLayer.category) {
			return false;
		}
		if (selectedLayer.category.code !== this.attrIndexService.cateCodeAddress && selectedLayer.category.code !== this.attrIndexService.cateCodeCenterline) {
			return false;
		} else {
			return true;
		}
	}

	private onClickRestoreLayers = async () => {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const layers = await this.layerService.getTestLayerList();
			const data: TestLayerSelectInputData = {
				layers: layers
			}
			const rsp = await this.modalService.openModalWindow(TestLayerSelectComponent, {
				maxHeight: '90%',
				minWidth: '380px',
				data: data
			});
			if (rsp && rsp.layerIds) {
				await this.layerService.publishLayers(rsp.layerIds, true);
				// reload
				location.reload();
			}
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	private onClickQcLayers = async () => {

		const layers = this.layerService.layerListBS.getValue().layers.filter(l => l.id).map(l => {
			return {
				id: l.id,
				label: l.category.nameShort
			}
		});
		const data: QcLayerSelectModalInput = {
			layers: layers
		}
		await this.modalService.openModalWindow(QcLayerSelectModalComponent, {
			maxHeight: '600px',
			minWidth: '380px',
			data: data
		});
	}
	private onClickFishboneAnalysis = async () => {
		const exist = await this.adminService.checkLongTransactions();
		if (!exist) {
			this.fishboneService.analyzeFishbone()
		}
	}
	private onClickReferenceDoc = async () => {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		let list: MapBookmark[] = [];
		try {
			list = await this.bookmarkService.getMapBookmarks('HREF');
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
		const data: ReferenceDocumentInputData = {
			bookmarkList: list
		}
		await this.modalService.openModalWindow(FeatReferenceDocumentComponent, {
			height: '500px',
			width: '700px',
			data: data
		});
	}

	onSelectAddress(e) {
		this.mapService.zoomToAddress(e);
	}

	ngOnInit() {
		const isAdmin = this.userService.getUserInfo().isAdmin;
		this.settingsMenu = [
			{
				label: 'Users Manage',
				navigateCommands: ['/azgiv/config/users'],
				hidden: !isAdmin
			}, {
				label: 'Agency Profile',
				navigateCommands: ['/azgiv/config/agency-profile'],
				hidden: !isAdmin
			},
			{
				label: 'Sub Agencies',
				navigateCommands: ['/azgiv/config/sub-agencies'],
				hidden: !isAdmin
			},
			// {
			// 	label: 'Integrators',
			// 	navigateCommands: ['/azgiv/config/integrators'],
			// 	hidden: !isAdmin
			// },
			{
				label: 'NAG',
				navigateCommands: ['/azgiv/config/nag'],
				hidden: !isAdmin
			},
			// {
			// 	label: 'Restore Layers',
			// 	onClick: this.onClickRestoreLayers,
			// 	hidden: AppSettings.envName !== 'dev' && AppSettings.envName !== 'test'
			// },
			{
				label: 'QC Layers',
				onClick: this.onClickQcLayers,
				hidden: !isAdmin
			}, {
				label: 'Fishbone Analysis',
				onClick: this.onClickFishboneAnalysis,
				hidden: !isAdmin
			},
			{
				label: 'Reference Documents',
				onClick: this.onClickReferenceDoc,
				hidden: !isAdmin
			},
			{
				label: 'User Guide',
				navigateCommands: ['/azgiv/user-guide']
			},
		];
		this.isAdminUser = this.userService.getUserInfo().isAdmin;
		this.agencyName = this.userService.getUserInfo().customerName;
		this.userName = this.userService.getUserInfo().userEmail;
		this.userRole = this.userService.getUserInfo().isAdmin ? 'Admin' : 'Operator'; // this.userService.userSubscription.role;
		this.customerType = this.userService.customerInfo.type;
		this.selectedCustomerSub = this.userService.selectedCustomer.subscribe((data) => {
			console.log('selectedCustomer', data);
			this.selectedCustomer = data;
			this.selectedCustomerId = data ? data.id : null;
		});
		this.selfCustomerId = this.userService.customerInfo.id;
		this.agencyParentName = this.userService.customerInfo.parentName;

		//
		this.userMenu.find(i => i.key === 'user').label = this.userRole + ': ' + this.userName;

		// schemaDefinedByList should be set before content menu subscription
		this.schemaDefinedByList = this.mainDataService.getSchemaDefinedBy();
		this.selectedSchema = this.schemaDefinedByList[0];

		this.contentMenuItemKeySub = this.mainDataService.contentMenuItemKeyBS.subscribe(data => {
			if (data) {
				this.hasModelMenu = this.checkHasModelMenu();

				const menu = this.contentMenus.find(m => m.key === data);
				if (menu !== this.selectedContentMenu) {
					this.selectContentMenu(menu);
				}
			}
		});
			// this.selectViewFromCodeSub = this.contentLayerService.selectViewFromCode.subscribe(data => {
			// 	const item = this.viewList.find(v => v.key === data);
			// 	if (item) {
			// 		this.selectView(item);
			// 	}
			// });
		this.modelSub = this.mainDataService.modelBS.subscribe(data => {
			if (!this.selectedModel || this.selectedModel.value !== data) {
				this.selectedModel = this.modelList.find(m => m.value === data);
			}
		});
		this.modelOptionSub = this.mainDataService.modelOptionBS.subscribe(data => {
			this.showAllField = data.hasAllFields;
		});
		this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(data => {
			this.hasModelMenu = this.checkHasModelMenu();
		})


		this.changeCustomerSub = this.paneHeaderService.changeCustomerSubject.subscribe(data => {
			this.selectedCustomerId = data;
		});
		this.transactionLogSub = this.transactionLogService.socketProcesses.subscribe(data => {
			if(data.length) {
				for (let i = 0; i < data.length; i ++) {
					if(data[i].status == 'Processing' || data[i].status == 'Preparing') {
						// this.longTransactionClass = 'glyphicons loading-dots';
						this.longTransactionClass = 'spinner-arrow';
						return;
					}
				}
				// this.longTransactionClass = 'glyphicons glyphicons-more';
				this.longTransactionClass = 'spinner-arrow-still';
			} else {
				this.longTransactionClass = 'spinner-arrow-still';
			}
		})
	}
	ngOnDestroy() {
		this.selectedCustomerSub.unsubscribe();
		this.contentMenuItemKeySub.unsubscribe();
		this.changeCustomerSub.unsubscribe();
		// this.selectViewFromCodeSub.unsubscribe();
		this.modelSub.unsubscribe();
		this.modelOptionSub.unsubscribe();
		this.selectedLayerSub.unsubscribe();
	}
}
